<script>
import Layout from '@layouts/loggedin.vue'

export default {
  components: {
    Layout,
  },
}
</script>

<template>
  <Layout>
    <iframe
      src="https://portal.productboard.com/qy7vidvq7qvfadxmfbueb7q2"
      frameborder="0"
      class="w-full min-h-screen"
    ></iframe>
  </Layout>
</template>
